import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import React from 'react';

export default function ComingSoon() {
    // Chakra Color Mode
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Text color="navy.500" fontSize="5xl" fontWeight="700" mx="auto" mt="4">
          Coming Soon
                </Text>
            </SimpleGrid>
        </Box>
    );
}
